import { graphQLClient } from './authService'
import userQueries from './graphql/users/queries'
import { Analytics } from '../types/analytics'

export type AllAnalyticsDTO = {
  customerId?: string
  locationId?: string
}

class AnalyticsService {
  getAll = async (options: AllAnalyticsDTO): Promise<Analytics> => {
    const where: { customerId?: string; place?: { id: string } } = {}

    if (options.locationId) {
      where.place = { id: options.locationId }
    }

    if (options.customerId) {
      where.customerId = options.customerId
    }

    const response = await graphQLClient.request(userQueries.getAnalytics, {
      where,
    })
    return response.analytics
  }
}

const analyticsService = new AnalyticsService()

export default analyticsService
